"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  SpecialOffers = _require.SpecialOffers;
const formatSpecialOffers = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$smallTitl = properties.smallTitle,
    smallTitle = _properties$smallTitl === void 0 ? '' : _properties$smallTitl,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$colorThem = properties.colorTheme,
    colorTheme = _properties$colorThem === void 0 ? '' : _properties$colorThem,
    _properties$porintId = properties.porintId,
    porintId = _properties$porintId === void 0 ? '' : _properties$porintId,
    _properties$backgroun = properties.backgroundPic,
    backgroundPic = _properties$backgroun === void 0 ? '' : _properties$backgroun,
    _properties$backgroun2 = properties.backgroundPicMo,
    backgroundPicMo = _properties$backgroun2 === void 0 ? '' : _properties$backgroun2,
    _properties$leftTitle = properties.leftTitle,
    leftTitle = _properties$leftTitle === void 0 ? '' : _properties$leftTitle,
    _properties$leftConte = properties.leftContent,
    leftContent = _properties$leftConte === void 0 ? '' : _properties$leftConte,
    _properties$leftRuleT = properties.leftRuleTxt,
    leftRuleTxt = _properties$leftRuleT === void 0 ? '' : _properties$leftRuleT,
    _properties$btnConfig = properties.btnConfiguration,
    btnConfiguration = _properties$btnConfig === void 0 ? {} : _properties$btnConfig,
    _properties$btnTxt = properties.btnTxt,
    btnTxt = _properties$btnTxt === void 0 ? '' : _properties$btnTxt,
    _properties$commodity = properties.commodityObject,
    commodityObject = _properties$commodity === void 0 ? '{}' : _properties$commodity,
    _properties$href = properties.href,
    href = _properties$href === void 0 ? '' : _properties$href,
    _properties$rightList = properties.rightList,
    rightList = _properties$rightList === void 0 ? [] : _properties$rightList;
  const formattedHref = formatUrlString(href);
  const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
  const commodityItem = _objectSpread(_objectSpread({}, resultCommodityObject), {}, {
    href: formattedHref
  });
  const onCallback = function () {
    window.asyncReceiveCommodity(commodityItem);
  };
  const _ref = btnConfiguration || {},
    richTextContent = _ref.richTextContent;
  const btnConfigurationHandled = _objectSpread(_objectSpread({}, btnConfiguration), {}, {
    richTextContent: formatUrlInText(richTextContent) // 规则弹窗里的富文本
  });
  return {
    modTitle,
    color,
    porintId,
    colorTheme,
    backgroundPic,
    backgroundPicMo,
    smallTitle,
    leftTitle,
    leftContent,
    leftRuleTxt,
    btnConfiguration: btnConfigurationHandled,
    btnTxt,
    rightList,
    extendProps: {
      'report-event': 'click_specialOffers_button',
      'report-ext1': btnTxt,
      'report-ext2': formattedHref
    },
    onCallback
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatSpecialOffers = formatSpecialOffers(data, {
        domains
      }),
      _formatSpecialOffers$ = _formatSpecialOffers.modTitle,
      modTitle = _formatSpecialOffers$ === void 0 ? '' : _formatSpecialOffers$,
      _formatSpecialOffers$2 = _formatSpecialOffers.smallTitle,
      smallTitle = _formatSpecialOffers$2 === void 0 ? '' : _formatSpecialOffers$2,
      _formatSpecialOffers$3 = _formatSpecialOffers.color,
      color = _formatSpecialOffers$3 === void 0 ? '' : _formatSpecialOffers$3,
      colorTheme = _formatSpecialOffers.colorTheme,
      backgroundPic = _formatSpecialOffers.backgroundPic,
      backgroundPicMo = _formatSpecialOffers.backgroundPicMo,
      _formatSpecialOffers$4 = _formatSpecialOffers.porintId,
      porintId = _formatSpecialOffers$4 === void 0 ? '' : _formatSpecialOffers$4,
      _formatSpecialOffers$5 = _formatSpecialOffers.leftTitle,
      leftTitle = _formatSpecialOffers$5 === void 0 ? '' : _formatSpecialOffers$5,
      _formatSpecialOffers$6 = _formatSpecialOffers.leftContent,
      leftContent = _formatSpecialOffers$6 === void 0 ? '' : _formatSpecialOffers$6,
      _formatSpecialOffers$7 = _formatSpecialOffers.leftRuleTxt,
      leftRuleTxt = _formatSpecialOffers$7 === void 0 ? '' : _formatSpecialOffers$7,
      _formatSpecialOffers$8 = _formatSpecialOffers.btnConfiguration,
      btnConfiguration = _formatSpecialOffers$8 === void 0 ? {} : _formatSpecialOffers$8,
      _formatSpecialOffers$9 = _formatSpecialOffers.btnTxt,
      btnTxt = _formatSpecialOffers$9 === void 0 ? '' : _formatSpecialOffers$9,
      _formatSpecialOffers$10 = _formatSpecialOffers.rightList,
      rightList = _formatSpecialOffers$10 === void 0 ? [] : _formatSpecialOffers$10,
      extendProps = _formatSpecialOffers.extendProps,
      onCallback = _formatSpecialOffers.onCallback;
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_specialOffers', componentKey, modTitle])), /*#__PURE__*/React.createElement(SpecialOffers, {
      style: bgStyle,
      colorTheme: colorTheme,
      backgroundPic: backgroundPic,
      backgroundPicMo: backgroundPicMo,
      smallTitle: smallTitle,
      mainTitle: modTitle,
      leftTitle: leftTitle,
      leftContent: leftContent,
      leftRuleTxt: leftRuleTxt,
      btnConfiguration: btnConfiguration,
      btnTxt: btnTxt,
      rightList: rightList,
      extendProps: extendProps,
      onCallback: onCallback
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}